export enum App {
  FieldForceManagement = 'FIELD_FORCE_MANAGEMENT',
  Greenland = 'GREENLAND',
  PorscheImportAgreements = 'PORSCHE_IMPORT_AGREEMENTS',
  PorscheStrategy2030 = 'PORSCHE_STRATEGY_2030',
  NetworkPlanning = 'NETWORK_PLANNING',
  RetailDesign = 'RETAIL_DESIGN',
  Survey = 'SURVEY',
  MultisensoryExperience = 'MULTISENSORY_EXPERIENCE',
  PcRoadmap = 'PC_ROADMAP',
  Apex = 'APEX',
}

export enum AppLink {
  Mpi = 'MPI',
}

export const APP_FALLBACK = 'kado';
